<template>
  <div>
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :bordered="tableBordered"
      :scroll="{ x: 1600}"
    >
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
    </a-table>
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => `共 ${total} 条`"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </div>
</template>

<script>
import { pageBrokerageDetailByUser } from '@/api/user/brokerage'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'BrokerageRecordForm',
  mixins: [tableMixin],
  props: {
    userId: {
      type: [String, Number],
      required: false,
      default: null
    }
  },
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        sendUserId: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '公司名称',
          dataIndex: 'companyName',
          width: 120,
          align: 'center'
        },
        {
          title: '员工姓名',
          dataIndex: 'nickname',
          width: 120,
          align: 'center'
        },
        {
          title: '身份证',
          dataIndex: 'idCard',
          width: 180,
          align: 'center'
        },
        {
          title: '入职日期',
          dataIndex: 'entryTime',
          width: 180,
          align: 'center'
        },
        {
          title: '离职日期',
          dataIndex: 'dimissionTime',
          width: 180,
          align: 'center'
        },
        {
          title: '所属年月',
          dataIndex: 'targetDate',
          width: 120,
          align: 'center'
        },
        {
          title: '发放日期',
          dataIndex: 'createTime',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '佣金合计',
          dataIndex: 'totalMoney',
          width: 120,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 120,
          align: 'center',
          customRender: function (status) {
            if (status == 0) {
              return '待审核'
            } else if (status == 1) {
              return '审核成功'
            } else if (status == 2) {
              return '审核失败'
            }
          }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  watch: {
    userId: {
      handler(val) {
        if (val) {
          this.queryParam.sendUserId = val
          this.getList()
        } else {
          this.list = []
          this.total = 0
        }
      },
      immediate: true
    }
  },
  methods: {
    /** 查询佣金记录列表 */
    getList() {
      this.loading = true
      pageBrokerageDetailByUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>

<style lang='less' scoped></style>
